import React, { useState } from 'react'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import FlexView from 'react-flexview/lib'
import EditIcon from '@material-ui/icons/Edit'
import NewFillButton from '../Core/NewFillButton'
import { ReactComponent as AddSvg } from '../../assets/add.svg'
import { Divider, Checkbox, FormControlLabel, Button } from '@material-ui/core'
import { awaitWithLoading } from '../../services/utils'
import { INSURANCE_CONTEXT_ACTIONS } from '../../context/InsuracePurchaseContext'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import policymanagementApi from '../../api/policymanagement.api'
import { Action } from '../../models/Action'
import { equivalentAdditionalInsured } from '../../services/utils'

export const AdditionalInsuredList = ({
  allAdditionalInsured,
  activeAdditionalInsured,
  onCheckBoxChange,
  onEdit,
}) => {
  return (
    <div className="ai-list">
      {activeAdditionalInsured.map((ai) => (
        <AdditionalInsuredCheckboxLine
          checked={true}
          ai={ai}
          onCheckBoxChange={onCheckBoxChange}
          onEdit={onEdit}
        />
      ))}
      {activeAdditionalInsured.length > 0 &&
        activeAdditionalInsured.length != allAdditionalInsured.length && (
          <Divider />
        )}
      {allAdditionalInsured
        .filter(
          (q) =>
            !activeAdditionalInsured.some(
              (r) =>
                equivalentAdditionalInsured(r, q) &&
                r.id == q.id &&
                r.newId == q.newId
            )
        )
        .map((ai) => (
          <AdditionalInsuredCheckboxLine
            checked={false}
            ai={ai}
            onCheckBoxChange={onCheckBoxChange}
            onEdit={onEdit}
          />
        ))}
    </div>
  )
}

const AdditionalInsuredCheckboxLine = ({
  ai,
  checked,
  onCheckBoxChange,
  onEdit,
}) => {
  return (
    <FlexView className="margin-top-small full-width space-between">
      <FlexView vAlignContent={'center'} className="text-overflow-elipsis">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={onCheckBoxChange}
              name={ai.id || ai.newId}
              color="primary"
            />
          }
          label={ai.name}
        />
      </FlexView>
      {checked && (
        <FlexView vAlignContent={'center'}>
          <EditIcon
            className="tiny-icon clickable small-margin-right"
            color="primary"
            onClick={() => onEdit(ai)}
          />
        </FlexView>
      )}
    </FlexView>
  )
}
